import { FutureActivityResponse } from '../../models/future-activites/future-activites.interfaces';
import {
  LoyaltyMemberTierLevel,
  StatusTrackerResponse
} from '../../models/status-tracker/api/api-status-tracker.interfaces';
import { TYPE } from '../../models/status-tracker/status-tracker.constants';
import { Tracker as TrackerContent } from '../../models/status-tracker/status-tracker.interfaces';
import { GenericLabel } from '../../models/utils';
import { getGenericLabel } from '../../services/utils';
import { getThreshold, getTierName, getYear } from './earnometer.utils';

export const getHeader = (
  futureMedallionData: LoyaltyMemberTierLevel,
  aem: TrackerContent
): GenericLabel => {
  return getGenericLabel(
    `${getYear(futureMedallionData.tierLevelStartLocalDate as string)} ${
      aem?.statusProgressLabel
    }`,
    futureMedallionData?.tierLevelCodeDesc || ''
  );
};

export const setInitialData = (
  futureActivities: FutureActivityResponse | undefined,
  api: StatusTrackerResponse
) => {
  const tier = getTierName(
    api.loyaltyMemberTierLevels?.filter(
      (tier) => tier.tierStatusDesc === TYPE.CURRENT
    )
  );

  const pending = (
    futureActivities?.totalFutureBalances
      ? futureActivities.totalFutureBalances.find(
          (balance) => balance.balanceTypeCode === TYPE.MQD
        )?.balanceAmt
      : 0
  ) as number;

  const mqdThreshold = getThreshold(
    api.currentLoyaltyMemberMedallionStatus,
    TYPE.MQD
  );

  const futureMedallionData = api.loyaltyMemberTierLevels.find(
    (tier) => tier.tierStatusDesc === TYPE.FUTURE
  );
  return { futureMedallionData, tier, pending, mqdThreshold };
};
